<template>
  <div>
    {{ ActDescBtn }}
    <table
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
      style="position: absolute"
      width="100%"
    >
      <!-- ContenidoBase-Mensajeros -->
      <tr height="48px" max-height="48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Creacion de Mensajeros que transportan'"
          :titulo="'Mensajeros'"
          @MethodAnular="NotifMessage"
          @MethodEliminar="NotifMessage"
          @MethodGuardar="guardar"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </tr>
      <!-- fn ContenidoBase-Mensajeros  -->

      <tr>
        <!-- BarraPrimaria-Mensajeros --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn color="yellow accent-4" small width="95%" @click.prevent="actualiza_tb_ver">
                    <i class="fa fa-eye" style="font-size: 25px"></i>
                    ver
                  </v-btn>
                </center>

                <BarraDinamicaNormal
                  ref="BarraDiNor"
                  :ContListSlot="[
                    { Text: 'Código', NomValue: 'codigo', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Nombre', NomValue: 'nombre', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Cedula', NomValue: 'cedula', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Telefono', NomValue: 'telefono', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Sucursal', NomValue: 'sucursal', Nv2: 'descripcion', Ctsl: 2, Type: 0, State: true },
                    { Text: 'Estado', NomValue: 'activo', Ctsl: 1, Type: 0.1, State: true },
                  ]"
                  :SeachNombre="'Búsqueda general'"
                  :emitnombre="'emitMensajeros'"
                  :headers="[
                    { text: 'Código', value: 'codigo' },
                    { text: 'Nombre', value: 'nombre' },
                    { text: 'Cedula', value: 'cedula' },
                    { text: 'Telefono', value: 'telefono' },
                    { text: 'Sucursal', value: 'sucursal.descripcion' },
                  ]"
                  :nombre="'Mensajeros'"
                  :url="$hostname + $hName + '/Mesajeros/findall/'"
                />
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria-Mensajeros  ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <div class="px-2">
              <!-- Formulario-Mensajeros  -->
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card color="grey lighten-3">
                  <div class="px-2">
                    <input v-model="mensajero.codigo" style="display: none" type="number" />

                    <v-row>
                      <!-- ----------------------------------------- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field
                          v-model="mensajero.nombre"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          label="* Nombre:"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-font" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                          <!-- :rules="[$rules.required]" -->
                        <!------------------------------- Sucursal:-->
                        <v-combobox
                          v-model="mensajero.sucursal"
                          :items="RSucursal"
                          autocomplete="off"
                          dense
                          item-text="descripcion"
                          label="Sucursal:"
                          outlined
                          @blur="SelctCbSucursal"
                          @focus="CargarRSucursal"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-sitemap" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>
                        <!------------------------------- meta de envio:-->
                        <v-text-field
                          v-model="mensajero.metadeenvios"
                          dense
                          label="Meta de Envios:"
                          outlined
                          @keyup="NumeralMen"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-flag-checkered" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                      </v-col>
                      <!-- ----------------------------------------- fn columna 1 -->

                      <!-- ----------------------------------------- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- ----------------------------------------- cedula  -->
                        <v-text-field
                          v-model="mensajero.cedula"
                          v-mask="'###-#######-#'"
                          :rules="[$rules.required, $rules.RulesCel]"
                          autocomplete="off"
                          dense
                          label="* Cédula:"
                          maxlength="13"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-id-card-o" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                        <!-- ----------------------------------------- telefono  -->
                        <v-text-field
                          v-model="mensajero.telefono"
                          v-mask="'(###)###-####'"
                          :rules="[$rules.required, $rules.RulesTel]"
                          autocomplete="off"
                          dense
                          label="* Teléfono:"
                          maxlength="13"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-phone" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!-- Activo:-->
                        <v-switch v-model="mensajero.activo" color="success" hide-details label="Activo"></v-switch>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>

                <!-- fn fila 3 -------------------------->
              </v-form>
              <!-- fn Formulario-Mensajeros  -->
            </div>
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          ></div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data todo general -->
    <v-dialog
      v-model="acti_tb_data"
      fullscreen
      hide-overlay
      label="myAlert"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" dense flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="[
                { text: 'Código', value: 'codigo', sortable: false, class: ['no-gutters black--text'] },
                { text: 'Nombre', value: 'nombre', sortable: false, class: ['no-gutters black--text'] },
                { text: 'Cedula', value: 'cedula', sortable: false, class: ['no-gutters black--text'] },
                { text: 'Telefono', value: 'telefono', sortable: false, class: ['no-gutters black--text'] },
                { text: 'Sucursal', value: 'sucursal.descripcion', sortable: false, class: ['no-gutters black--text'] },
              ]"
              :items="list"
              :items-per-page="15"
              :search="search"
              dense
              @click:row="datostabla"
            ></v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn tb-data todo general -->

    <!-- ------------------------------------------------------ Modal-notificacion general -->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            v-if="notif.Exec == 'eliminarMensajero'"
            small
            @click.prevent="eliminar(), (notif.estado = !notif.estado)"
          >
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="notif.estado = !notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Modal-notificacion general -->

    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->

    <!--- Dialogo de confirmacion --->
    <DialogoConfirmacion ref="confirmDialog" :texto="confirmacionTexto" :titulo="confirmacionTitulo" />

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import BarraDinamicaNormal from "../../components/BarraDinamicaNormal"
  import { EventBus } from "../../event-bus"
  import { mask } from "vue-the-mask"
  import ContenidoBase from "../../components/ContenidoBase"
  import DialogoConfirmacion from "@/components/DialogoConfirmacion.vue"

  export default {
    components: {
      DialogoConfirmacion,
      BarraBusqueda2,
      BarraDinamicaNormal,
      ContenidoBase,
    },

    directives: {
      mask,
    },

    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("emitMensajeros", this.datostabla)
      // EventBus.$on("MensajerosNew", this.new);
      // EventBus.$on("MensajerosSave", this.save);
      // EventBus.$on("MensajerosRemove", this.remove);
      // EventBus.$on("MensajerosAnular", this.anular);
      // EventBus.$on("MensajerosPrintList", this.imprimirList);
      this.filtro()
    },

    created() {
      var json = {
        titulo: "Mensajeros",
        descripcion: "Creacion de Mensajeros que transportan",
        save: true,
        eliminar: false,
        anular: false,
        nuevo: true,
        imprimir: false,

        accion: ["MensajerosNew", "MensajerosSave", "MensajerosRemove", "MensajerosAnular", "MensajerosPrintList"],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },

    data() {
      return {
        windowSize: { width: "auto", height: "auto" },
        RSucursal: [],

        valid: true,

        mensajero: {
          codigo: 0,
          nombre: null,
          cedula: "",
          sucursal: "",
          telefono: "",
          metadeenvios: 0,
          activo: true,
        },

        EstadoBtn: {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: true,
          anular: true,
          imprimir: true,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        },

        headers: [{ text: "Mensajero", value: "nombre" }],

        slotlist: [
          { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
          { dt0: "nombre", dt1: null, dt2: null, dt3: 1, dt4: "Nombre:" },
          { dt0: "cedula", dt1: null, dt2: null, dt3: 1, dt4: "Cedula:" },
          { dt0: "telefono", dt1: null, dt2: null, dt3: 1, dt4: "Teléfono:" },
          { dt0: "sucursal", dt1: "descripcion", dt2: null, dt3: 1, dt4: "Sucursal:" },
          { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
        ],

        list: [],
        search: "",
        acti_tb_data: false,

        ejecucion: true,
        aalert: {
          estado: false,
          color: null,
        },

        notif: {
          estado: false,
          nombre: "",
          Exec: "",
        },

        confirmacionTexto: "",
        confirmacionTitulo: "",

        BarraTablaDinamicaAprir: false,
        BarraSecundariaAprir: false,
      }
    },

    methods: {
      NumeralMen(e) {
        if (e.key) {
          var mynumeral = require("numeral")
          this.mensajero.metadeenvios = mynumeral(this.mensajero.metadeenvios).value()
          if (this.mensajero.metadeenvios == null) {
            this.mensajero.metadeenvios = 0
          }
        } else {
          console.log("no se puede poner letras o signos")
        }
      },

      // Comprobando si el valor de la selección es nulo o indefinido.
      SelctCbSucursal() {
        if (this.mensajero.sucursal == null) {
          this.mensajero.sucursal = ""
        }

        if (this.mensajero.sucursal.codigo == undefined) {
          this.alerta("Seleccione una sucursal", "error")
          this.mensajero.sucursal = ""
        }
      },

      // Abriendo una tabla y muestra todo los registros.
      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir

        if (this.BarraTablaDinamicaAprir == true) {
          this.$refs.BarraDiNor.list = []
          this.$refs.BarraDiNor.filtro()
        }
      },

      abrirTabla2() {
        this.BarraSecundariaAprir = !this.BarraSecundariaAprir
      },

      // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RSucursal.
      CargarRSucursal() {
        this.$axios
          .get(this.$hostname + this.$hName + "/sucursal/findallActivos/", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.RSucursal = JSON.parse(JSON.stringify(res.data))
          })
      },

      alerta(e, l) {
        if (l === "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e

          this.newnuevo()
          this.ejecucion = false
        }

        if (l === "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e

          this.ejecucion = false
        }
      },

      guardar() {
        if (!this.$refs.form.validate()) {
          this.alerta("los campos en rojo son Requeridos", "error")
          return
        }

        if (this.mensajero.codigo === 0) {
          this.save()
        } else {
          this.modify()
        }
      },

      // Guardar un mensajero nuevo
      save() {
        this.ejecucion = true

        this.$axios
          .post(this.$hostname + this.$hName + "/Mesajeros", this.mensajero, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Mensajero creado exitosamente!", "bien")
          })
          .catch(async (error) => {
            if (error.response.status === 409) {
              this.confirmacionTexto = error.response.data
              this.confirmacionTitulo = "Conflicto"
              if (await this.$refs.confirmDialog.show()) {
                this.restaurarMensajero()
              }
              return
            }
            this.alerta("Error al crear mensajero!", "error")
          })
      },

      // Actualizar un mensajero ya existente
      modify() {
        this.ejecucion = true

        this.$axios
          .put(this.$hostname + this.$hName + "/Mesajeros", this.mensajero, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Mensajero modificado exitosamente!", "bien")
          })
          .catch((error) => {
            if (error.response.status === 409) {
              this.alerta(error.response.data, "error")
            } else {
              this.alerta("Error al modificar mensajero!", "error")
            }
          })
      },

      // Restaura un mensajero ya existente, pero que fue eliminado previamente
      restaurarMensajero() {
        this.ejecucion = true
        let cedula = this.mensajero.cedula

        this.$axios
          .put(this.$hostname + this.$hName + `/Mesajeros/restore/${cedula}`, null, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Mensajero restaurado exitosamente!", "bien")
            this.mensajero = res.data
          })
          .catch((error) => {
            this.alerta("Error al restaurar mensajero!", "error")
          })
      },

      // Crear un objeto de notificación y luego llamar al metodo Exec_notif().
      NotifMessage() {
        if (this.mensajero.codigo != 0 && this.mensajero.codigo != null) {
          var notif = {
            estado: true,
            nombre: "¿Seguro que desea eliminar este registro?",
            Exec: "eliminarMensajero",
          }

          this.Exec_notif(notif)
        } else {
          this.alerta("Seleccione un Mensajero para eliminar", "error")
        }
      },

      Exec_notif(e) {
        this.notif = JSON.parse(JSON.stringify(e))
      },

      // Envío de una solicitud a un api para borrar el mensajero
      eliminar() {
        if (this.mensajero.codigo != 0 && this.mensajero.codigo != null) {
          if (this.$refs.form.validate()) {
            var mensajero = JSON.parse(JSON.stringify(this.mensajero))
            this.$axios
              .post(this.$hostname + this.$hName + "/Mesajeros/borrado/", mensajero, {
                headers: this.$store.getters.GetheadersAxios,
              })
              .then((res) => {
                this.alerta(res.data.mensage, res.data.estado)
              })
              .catch((error) => this.alerta("Dato no guardado correctamente", "error"))
          }
        }
      },

      anular() {},

      // Abriendo una nueva ventana y escribiendo el pdf en ella.
      imprimirList() {
        let headers = this.$store.getters.GetheadersAxios

        this.$axios.get(this.$hostname + this.$hName + "/Mesajeros/imprimir/", { headers: headers }).then((res) => {
          var PDF = `data:application/pdf;base64,${encodeURI(res.data)}`
          EventBus.$emit("openPDF", PDF, "mesajeros")
        })
      },

      // Abriendo una ventana modal.
      newnuevo() {
        this.BarraTablaDinamicaAprir = false
        this.mensajero = {
          codigo: 0,
          nombre: null,
          cedula: "",
          sucursal: "",
          telefono: "",
          metadeenvios: 0,
          activo: true,
        }
        this.ejecucion = true
        EventBus.$emit("actualizaBarraBusqueda2")
      },

      // Tomando los datos de la tabla y poniéndolos en un formulario.
      datostabla(e) {
        var mensajero = JSON.parse(JSON.stringify(e))

        mensajero.nombre = JSON.parse(JSON.stringify(e.nombre.trim()))
        mensajero.cedula = JSON.parse(JSON.stringify(e.cedula.trim()))
        mensajero.telefono = JSON.parse(JSON.stringify(e.telefono.trim()))
        this.mensajero = mensajero

        this.acti_tb_data = false

        if (this.windowSize.width <= 600) {
          this.BarraTablaDinamicaAprir = false
        }
      },

      // Un metodo que se llama cuando se hace clic en un botón.
      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.filtro()
      },

      // Hacer una solicitud GET al servidor y devolver los datos a la variable de lista.
      async filtro() {
        var headers = this.$store.getters.GetheadersAxios
        await this.$axios
          .get(this.$hostname + this.$hName + "/Mesajeros/findall/", { headers: headers })
          .then((res) => {
            this.list = res.data
          })
      },
    },

    computed: {
      ActDescBtn() {
        if (this.mensajero.codigo > 0) {
          this.EstadoBtn = {
            BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: true,
            eliminar: true,
            anular: false,
            imprimir: true,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }
        }

        if (this.mensajero.codigo <= 0) {
          this.EstadoBtn = {
            BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: true,
            eliminar: false,
            anular: false,
            imprimir: true,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }
        }

        this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
      },
    },
  }
</script>

<style scoped>
  i {
    width: 20px;
  }
</style>
